/** 邮箱注册：字母开头；仅字母、数字、下划线、横线、英文句号 */
export const USERNAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9_.-]*$/

export function isValidUsername(value) {
  return typeof value === 'string' && USERNAME_PATTERN.test(value)
}

export const USERNAME_HINT =
  '用户名须以字母开头，仅可包含字母、数字、下划线（_）、横线（-）或英文句号（.）'

/** 自定义登录名：至少 5 位，字母数字及 _ . - */
export const WECHAT_USERNAME_PATTERN = /^[a-zA-Z0-9._-]{5,32}$/

export const WECHAT_USERNAME_MIN_LEN = 5
export const WECHAT_USERNAME_MAX_LEN = 32

export const WECHAT_USERNAME_HINT =
  '登录名至少 5 位，仅可使用字母、数字、下划线（_）、英文句号（.）、横线（-）；系统临时登录名仅可修改一次，改后不可再改。登录名 ≠ 昵称'

const USERNAME_BANNED_WORDS = [
  'porn', 'sex', 'naked', 'nude', 'nudes', 'fuck', 'shit', 'bitch',
  'pussy', 'dick', 'cock', 'tits', 'boobs', 'hentai', 'nsfw', 'xxx',
  'asshole', 'nigger', 'faggot', 'rape', 'slut', 'whore', 'dildo',
  'penis', 'vagina', 'anal', 'cum'
]

const WECHAT_AUTO_PATTERN = /^wx_[a-zA-Z0-9]{10,29}$/i
// 历史自动登录名：UUID 形态，末段 6~12（如 89168897-23f7-4643-941e-1cf889de）
const LEGACY_AUTO_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{6,12}$/i

export function isAutoGeneratedUsername(username) {
  if (!username || typeof username !== 'string') return false
  const name = username.trim()
  return WECHAT_AUTO_PATTERN.test(name) || LEGACY_AUTO_PATTERN.test(name)
}

/** 仅系统自动临时登录名且尚未自定义时可改一次 */
export function canChangeUsername(username, customized) {
  return Number(customized || 0) === 0 && isAutoGeneratedUsername(username)
}

function containsBannedUsernameWord(value) {
  const lower = String(value).toLowerCase()
  const compact = lower.replace(/[._-]/g, '')
  return USERNAME_BANNED_WORDS.some((word) => lower.includes(word) || compact.includes(word))
}

/** @returns {{ ok: boolean, message: string }} */
export function validateWechatUsernameChange(value) {
  const name = typeof value === 'string' ? value.trim() : ''
  if (!name) {
    return { ok: false, message: '请填写用户名' }
  }
  if (name.length < WECHAT_USERNAME_MIN_LEN) {
    return { ok: false, message: `用户名至少 ${WECHAT_USERNAME_MIN_LEN} 位` }
  }
  if (name.length > WECHAT_USERNAME_MAX_LEN) {
    return { ok: false, message: `用户名不能超过 ${WECHAT_USERNAME_MAX_LEN} 位` }
  }
  if (!WECHAT_USERNAME_PATTERN.test(name)) {
    return { ok: false, message: '用户名仅可包含字母、数字、下划线（_）、横线（-）或英文句号（.）' }
  }
  if (!/[a-zA-Z0-9]/.test(name)) {
    return { ok: false, message: '用户名须包含字母或数字' }
  }
  if (isAutoGeneratedUsername(name) || containsBannedUsernameWord(name)) {
    return { ok: false, message: '用户名含有不当词汇或不可用，请更换' }
  }
  return { ok: true, message: '' }
}

export function isValidWechatUsernameChange(value) {
  return validateWechatUsernameChange(value).ok
}
